module.exports = __webpack_public_path__ + "0ed119908a0a758ba6ee0c6b3e05e148.png";